module.exports = "././img/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 832
// module chunks = 0